import React, { useEffect } from 'react';
import Bredcom from '../../Bredcom/Main';
import Header from '../../headerone/Main';
import Blog from '../../menhome/Blog';
import Event from '../../menhome/Event';
import Newlast from '../../menhome/Newlast';
import Commandcsd from '../mencsdcommand/Commandcsd';





function Main() {

  useEffect(() => {
    document.getElementById("title").innerHTML="CSD Command";
  }, [])

  return (
    <>
         <Header/>

         <div className="page-wrapper">
          <Bredcom 
            subtitle="Home"
            title="csd command"
            subtitledown="CSD Command"
           />
            <Commandcsd/>
            <Event/>
            <Blog/>
            <Newlast/>
         </div>
    </>
  )
}

export default Main